export const COLOR = {
    BASE: {
        PAGE: '#eeeeee',
        DIVIDER: '#e6e6e6',
        DIVIDER2: '#333333',
        SCRIM_LIGHT: 'rgba(0, 0, 0, 0.6)',
        SCRIM_DARK: 'rgba(0, 0, 0, 0.8)',
        SHADOW_SHORT: 'rgba(0, 0, 0, 0.3)',
        SHADOW_LONG: 'rgba(0, 0, 0, 0.5)',
    },
    BRAND: {
        BACKGROUND1: '#ffffff',
        BACKGROUND2: '#ffffff',
        BACKGROUND3: '#06ffd8',
        BACKGROUND4: '#ffffff',
        BACKGROUND5: '#e6e6e6',
        BACKGROUND6: '#333333',
        BACKGROUND7: '#000000',
        FOREGROUND1: '#000000',
        FOREGROUND2: '#333333',
        FOREGROUND3: '#666666',
        FOREGROUND4: '#e6e6e6',
        FOREGROUND5: '#000000',
        FOREGROUND6: '#ffffff',
        FOREGROUND7: '#c3c3c3',
        ACCENT1: '#06ffd8',
        ACCENT2: '#06ffd8',
        ACCENT3: '#6900ff',
        CTA1: '#06ffd8',
        CTA2: '#6900ff',
    },
    SEMANTIC: {
        ERROR1: '#fb4444',
        ERROR2: '#ffd8d8',
        WARNING1: '#fbe044',
        WARNING2: '#fdf3b7',
        SUCCESS1: '#00ba91',
        SUCCESS2: '#bfebe1',
    },
    RESERVED: {
        BLACK: '#2d2d2e',
        WHITE: '#f9f9f9',
        TRANSPARENT: 'rgba(249, 249, 249, 0)',
    },
};

export const FONT = {
    FAMILY: 'Open Sans, sans-serif',
    FAMILY_SECOND: 'SharpGroteskBook25, sans-serif',

    WEIGHT_NORMAL: 400,
    WEIGHT_SEMI_BOLD: 600,
    WEIGHT_BOLD: 700,

    SIZE_XXSMALL: 12,
    SIZE_XSMALL: 12,
    SIZE_SMALL: 13,
    SIZE_MEDIUM: 14,
    SIZE_LARGE: 16,
    SIZE_XLARGE: 18,
};

export const BASIC_PALETTE = {
    FONT_FAMILY: 'Open Sans, sans-serif',

    FONT_HEADER4: {
        fontFamily: FONT.FAMILY_SECOND,
        fontSize: FONT.SIZE_XSMALL,
        fontWeight: FONT.WEIGHT_SEMI_BOLD,
        textTransform: 'capitalize',
    },
    FONT_BODY_MEDIUM: {
        fontSize: 14,
        fontWeight: 600,
    },

    FILL_PAGE: COLOR.BASE.PAGE,
    FILL_HEADER: COLOR.BRAND.BACKGROUND6,
    FILL_HERO: COLOR.BRAND.BACKGROUND6,
    FILL_SHEET: COLOR.BRAND.BACKGROUND1,
    FILL_POPOVER: COLOR.BASE.PAGE,

    FILL_CONTENT_DEFAULT: COLOR.BRAND.BACKGROUND1,
    FILL_CONTENT_PROMINENT: COLOR.BRAND.BACKGROUND6,

    FILL_CARD: COLOR.BRAND.BACKGROUND1,
    FILL_CARD_PROMINENT: COLOR.BRAND.BACKGROUND1,

    FILL_CONTROL_OUTLINE: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
    FILL_CONTROL_ACCENT: COLOR.BRAND.FOREGROUND5,
    FILL_CONTROL_ODDS: COLOR.BRAND.BACKGROUND5,

    FILL_ACCENT_PRIMARY: '#06ffd8',
    FILL_ACCENT_SECONDARY: '#06ffd8',
    FILL_ACCENT_FOCUS: COLOR.BRAND.ACCENT3,

    FILL_SELECTED_PRIMARY: COLOR.BRAND.FOREGROUND5,
    FILL_SELECTED_ODDS: COLOR.BRAND.ACCENT1,

    DEFAULT_PRIMARY_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
    DEFAULT_SECONDARY_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND3}`,

    TEXT_ODDS_PRIMARY: '#000000',
    TEXT_ODDS_SECONDARY: COLOR.BRAND.FOREGROUND2,

    TEXT_ACCENT_PRIMARY: '#000000',
    TEXT_ACCENT_SECONDARY: '#333333',
    TEXT_ACCENT_FILL: '#6900ff',

    TEXT_SELECTED_ODDS: '#000000',

    DEFAULT_GENERIC_ACCENT_COLOR: COLOR.BRAND.CTA2,
    DEFAULT_DIVIDER: COLOR.BASE.DIVIDER,

    DEFAULT_BUTTON_BORDER_RADIUS: 20,
};
